import React from "react";

import { Container, ErrorMessage, Input, Label, Title } from "./styles";
import useAddReservation from "../../hooks/useAddReservation";
import { Button, LoaderComponent, SuccessScreen } from "../../components/";
import assets from "../../assets/index";
import { useNavigate } from "react-router-dom";
import { useBookingEngine } from "../../context/BookingEngineContext";

const AddReservationScreen = () => {
  const {
    loading,
    errorMessage,
    showSuccessScreen,
    referenceCode,
    lastName,
    setReferenceCode,
    setLastName,
    addReservation,
  } = useAddReservation();
  const navigate = useNavigate();
  const { bookingEngineData } = useBookingEngine();
  const handleSubmit = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    await addReservation();
  };

  if (loading) {
    return <LoaderComponent content="Adding reservation ..." />;
  }

  return (
    <Container>
      {" "}
      {!showSuccessScreen && (
        <Title>
          <span className="go-back" onClick={() => navigate("/home")}>
            <img src={assets.GoBack} alt="" />
          </span>
          Add Reservation
        </Title>
      )}
      <div style={{ width: 300, marginTop: -140 }}>
        <form onSubmit={handleSubmit}>
          <Label>Reservation ID</Label>
          <Input
            type="text"
            placeholder="Enter reservation ID"
            value={referenceCode}
            onChange={(e) => setReferenceCode(e.target.value)}
            required
          />
          <Label>Last name</Label>
          <Input
            type="text"
            placeholder="Enter last name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
          />

          <Button
            type="submit"
            label="Add Reservation"
            style={{
              marginTop: 20,
              height: 50,
              borderRadius: 25,
              fontWeight: 500,
            }}
          />
        </form>

        <img
          src={assets.SuitcaseVector}
          alt=""
          className="suitcase-guy"
          style={{
            filter: bookingEngineData ? "grayscale(1)" : "grayscale(0)",
          }}
        />

        {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
        {showSuccessScreen && (
          <SuccessScreen
            imageSrc={assets.SuccessVector}
            title="Reservation added."
            content={`Your reservation with id ${referenceCode} under the last name ${lastName} was added successfully.`}
            buttonElement={
              <Button
                style={{
                  height: 50,
                  borderRadius: 25,
                  fontWeight: 500,
                  width: "300px",
                  marginTop: 20,
                  cursor: "pointer",
                }}
                label="See Reservations"
                onClick={() => navigate("/reservations")}
              />
            }
          />
        )}
      </div>
    </Container>
  );
};

export default AddReservationScreen;
